import { useState } from "react"
import {
  TooltipButton,
  type TooltipButtonProps,
} from "@/v2-backoffice-client/components/button"
import type { InvitationFragment } from "@/v2-backoffice-client/invitation/__types__/invitation.fragment"
import InvitationUpdateDialog from "@/v2-backoffice-client/invitation/update/InvitationUpdateDialog"

export type InvitationUpdateButtonProps = Omit<
  TooltipButtonProps,
  "content" | "onClick"
> & {
  invitation: InvitationFragment
}

function InvitationUpdateButton(props: InvitationUpdateButtonProps) {
  const { invitation, children, ...tooltipButtonProps } = props
  const [isOpen, setIsOpen] = useState(false)

  return (
    <>
      <TooltipButton
        variant="ghost"
        size="tiny"
        iconSrc="pencil"
        content="Update invitation"
        isSquare={!children}
        onClick={(e) => {
          e.stopPropagation()
          setIsOpen(true)
        }}
        {...tooltipButtonProps}
      >
        {children}
      </TooltipButton>

      <InvitationUpdateDialog
        invitation={invitation}
        open={isOpen}
        onOpenChange={setIsOpen}
      />
    </>
  )
}

export default InvitationUpdateButton
